import { render, staticRenderFns } from "./DemoGridPanel.vue?vue&type=template&id=018b1aa2&"
import script from "./DemoGridPanel.vue?vue&type=script&lang=js&"
export * from "./DemoGridPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports